export default "__VITE_ASSET__lXlKdCz2__"